import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

const CheckEmail = () => {
  const email = "joanne.demo@gmail.com"; // You can make this dynamic from state or props

  const handleResend = () => {
    // TODO: call API to resend email
    alert("Resend email clicked! Implement API call here.");
  };

  return (
    <div className="wrapper">
      <section className="signin-page check_email">
        <Container fluid className="p-0">
          <div className="signin_inner">
            <Row className="align-items-center gx-0">
              
              {/* LEFT IMAGE */}
              <Col md={12} lg={6}>
                <div className="signin-left">
                  <img
                    src="/images/login_bg.png"
                    className="img-fluid login_bg"
                    alt="login_bg"
                  />
                </div>
              </Col>

              {/* RIGHT CONTENT */}
              <Col md={12} lg={6}>
                <div className="signin-right w-100 p-4">
                  <div className="logo mb-4">
                    <img
                      src="/images/logo.png"
                      className="img-fluid mb-4"
                      alt="logo"
                    />

                    <span className="key_icon mb-4 d-block">
                      <svg
                        width="19"
                        height="15"
                        viewBox="0 0 19 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.80775 15C1.30258 15 0.875 14.825 0.525 14.475C0.175 14.125 0 13.6974 0 13.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H17.1923C17.6974 0 18.125 0.175 18.475 0.525C18.825 0.875 19 1.30258 19 1.80775V13.1923C19 13.6974 18.825 14.125 18.475 14.475C18.125 14.825 17.6974 15 17.1923 15H1.80775ZM9.5 8.05775L1.5 2.94225V13.1923C1.5 13.2821 1.52883 13.3558 1.5865 13.4135C1.64417 13.4712 1.71792 13.5 1.80775 13.5H17.1923C17.2821 13.5 17.3558 13.4712 17.4135 13.4135C17.4712 13.3558 17.5 13.2821 17.5 13.1923V2.94225L9.5 8.05775ZM9.5 6.5L17.3463 1.5H1.65375L9.5 6.5ZM1.5 2.94225V1.5V13.1923C1.5 13.2821 1.52883 13.3558 1.5865 13.4135C1.64417 13.4712 1.71792 13.5 1.80775 13.5H1.5V2.94225Z"
                          fill="#2491BB"
                        />
                      </svg>
                    </span>

                    <h2 className="font_24 clr_blue font-600 mb-2">
                      Check your email
                    </h2>
                    <p className="clr_grey font_14 font-400">
                      We have sent you password reset instructions on email address <b>{email}</b>.
                    </p>
                  </div>

                  {/* Buttons */}
                  <div className="d-grid gap-2">
                    <Link
                      to="/login"
                      className="btn sky_theme w-100 py-2 d-flex align-items-center justify-content-center"
                    >
                      <i className="fa-solid fa-arrow-left me-2"></i> Back to Log In
                    </Link>

                    <p className="not_recived font_14 font-400 clr_grey d-flex align-items-center justify-content-center gap-2 mt-3">
                      Didn’t receive the email?
                      <Button
                        variant="link"
                        className="p-0 clr_sky font_14 font-500 back_login"
                        onClick={handleResend}
                      >
                        Resend
                      </Button>
                    </p>
                  </div>
                </div>
              </Col>

            </Row>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default CheckEmail;
